// Launch feature flags. The backend .env is the single source of truth; it is
// exposed via GET /api/config and enforced server-side. The web app hydrates
// the backend-controlled flags (shop, supplierPortal) from a synchronous cache
// on load and refreshes that cache from /api/config on launch.
const CONFIG_KEY = 'hg_app_config';

let remote = {};
try {
  remote = JSON.parse(localStorage.getItem(CONFIG_KEY) || '{}') || {};
} catch {
  remote = {};
}

export const FEATURES = {
  seedBox: false, // Seed Box + its seed-packet scanner (hidden for now)
  pantry: true, // Pantry Planner (free for everyone)
  shop: remote.shop_enabled === true, // Boutique Shop (backend-controlled)
  supplierPortal: remote.supplier_portal_enabled === true, // Supplier Portal (backend-controlled)
};

// Fetch the latest flags from the backend and cache them for the next load.
export async function refreshRemoteConfig() {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    const res = await fetch(`${base}/api/config`);
    if (!res.ok) return;
    const cfg = await res.json();
    localStorage.setItem(CONFIG_KEY, JSON.stringify(cfg));
    FEATURES.shop = cfg.shop_enabled === true;
    FEATURES.supplierPortal = cfg.supplier_portal_enabled === true;
  } catch {
    // Offline: keep the cached flags.
  }
}
